module.exports = __webpack_public_path__ + "media/images/social-logos/whatsapp-c4fc8da2919ba07ebfe2b5eca6988b38.svg";